
import {
  administradorEmpresas, gestorEmpresa,
  empleado, firmaRL, firmaRRHH, reportes,
  estructuraOrganizacional,
  gestionTramites,
  gestionNotificacion,
  gestionLegajos,
  verNotificaciones
} from './constans/constants'
import { ReactComponent as AssignmentIcon } from "./assets/images/icons/assignment.svg";
import { ReactComponent as InboxIcon } from "./assets/images/icons/inbox.svg";
import { ReactComponent as InventoryIcon } from "./assets/images/icons/inventory.svg";
import { ReactComponent as LanIcon } from "./assets/images/icons/lan.svg";
import { ReactComponent as NotificationsIcon } from "./assets/images/icons/notifications.svg";
import { ReactComponent as PersonIcon } from "./assets/images/icons/person.svg";
import { ReactComponent as SettingsIcon } from "./assets/images/icons/settings.svg";
import { ReactComponent as DescriptionIcon } from "./assets/images/icons/description.svg";
import { ReactComponent as NotificationIcon } from "./assets/images/icons/notifications.svg";

const categories = [
/*   {
    id: 'Administracion',
    rol: [administradorEmpresas],
    url: '/administracion/usuarios',
    raiz: '/administracion',
    icon: PersonIcon
  },
  {
    id: 'Configuracion',
    rol: [gestorEmpresa],
    url: '/configuracion/tipo-documento',
    raiz: '/configuracion',
    icon: SettingsIcon
  }, */
    {
    id: 'Bandeja',
    rol: [empleado],
    url: '/bandeja/pendientes',
    raiz: '/bandeja',
    icon: InboxIcon
  },
    {
    id: 'Lotes',
    rol: [gestorEmpresa, firmaRL, firmaRRHH],
    url: '/lote/nuevos',
    raiz: '/lote',
    icon: InventoryIcon
  },
  {
    id: 'Estructura Organizacional',
    rol: [estructuraOrganizacional],
    url: '/estructura/organizacion',
    raiz: '/estructura',
    icon: LanIcon
  },
   {
    id: 'Notificaciones',
    rol: [gestionNotificacion, verNotificaciones],
    url: '/notificaciones/todos',
    raiz: '/notificaciones',
    icon: NotificationIcon
  },
  // {
  //   id: 'Legajos',
  //   rol: [gestionLegajos],
  //   url: '/administracion/legajos',
  //   raiz: '/administracion/legajos',
  //   icon: PersonIcon
  // },
  {
    id: 'Reportes',
    rol: [gestorEmpresa,reportes],
    url: '/reporte/recibo-colaborador/todos',
    raiz: '/reporte',
    icon: AssignmentIcon
  }
];
export default categories;